<router-outlet />
<div class="overlay" *ngIf="showOverlay$ | async"></div>
